import { CanMakePaymentResult } from '@stripe/stripe-js'

import { PaymentMethod } from 'modules/purchase/constants'
import { TPaymentRequestPaymentMethod } from 'modules/purchase/types'

export const getPaymentRequestPaymentMethod = (
  result: CanMakePaymentResult | null,
): TPaymentRequestPaymentMethod | undefined => {
  if (result?.applePay) {
    return PaymentMethod.APPLE_PAY
  }

  if (result?.googlePay) {
    return PaymentMethod.GOOGLE_PAY
  }

  return undefined
}
